// import React, { useEffect } from "react";
// import { useNavigate, useSearchParams } from "react-router-dom";
// import { EyeIcon, EyeSlashIcon, CheckCircleIcon } from "@heroicons/react/24/outline";
// import { useAuth } from "../../../shared/hooks/useAuth";
// import { useFormValidation, validationRules } from "../../../shared/hooks/useFormValidation";

// const ResetPassword = () => {
//   // React Router Hooks
//   const navigate = useNavigate();
//   const [searchParams] = useSearchParams();

//   // Extract token & email from URL
//   const token = searchParams.get("token");
//   const email = searchParams.get("email");

//   // Auth Hook
//   const { resetPassword, isLoading, error } = useAuth();

//   // Form Validation Hook
//   const { values, errors, handleChange, handleBlur, validate } = useFormValidation(
//     {
//       password: "",
//       confirmPassword: "",
//     },
//     {
//       password: validationRules.password,
//       confirmPassword: validationRules.confirmPassword,
//     }
//   );

//   // Local State for Show/Hide Passwords
//   const [showPassword, setShowPassword] = React.useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
//   const [isSuccess, setIsSuccess] = React.useState(false);

//   // Token Validation
//   useEffect(() => {
//     if (!token) navigate("/forgot-password");
//   }, [token, navigate]);

//   // Handle Form Submit
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;

//     const success = await resetPassword(values.password, token, email);
//     if (success) setIsSuccess(true);
//   };

//   // Password Strength Meter
//   const passwordStrength = (() => {
//     const pass = values.password;
//     let strength = 0;
//     if (pass.length >= 8) strength++;
//     if (/[a-z]/.test(pass)) strength++;
//     if (/[A-Z]/.test(pass)) strength++;
//     if (/\d/.test(pass)) strength++;
//     if (/[!@#$%^&*]/.test(pass)) strength++;
//     return strength;
//   })();

//   const strengthLabels = ["Very Weak", "Weak", "Fair", "Good", "Strong"];
//   const strengthColors = ["bg-red-500", "bg-orange-500", "bg-yellow-500", "bg-blue-500", "bg-green-500"];

//   // ✅ Success Page
//   if (isSuccess) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-purple-50 p-4">
//         <div className="max-w-md w-full text-center space-y-6 bg-white rounded-xl shadow-lg p-8">
//           <div className="mx-auto h-16 w-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
//             <CheckCircleIcon className="h-8 w-8 text-green-600" />
//           </div>
//           <h2 className="text-3xl font-bold text-gray-900">Password Reset Successful!</h2>
//           <p className="text-gray-600">Your password has been successfully updated.</p>
//           <button onClick={() => navigate("/login")} className="w-full common-gradiant text-white py-3 rounded-xl font-semibold">
//             Continue to Login
//           </button>
//         </div>
//       </div>
//     );
//   }

//   // ✅ Reset Password Form
//   return (
//     <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-purple-50 p-4">
//       <div className="max-w-md w-full">
//         <div className="text-center mb-8">
//           <div className="mx-auto h-16 w-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-xl flex items-center justify-center mb-4">
//             <span className="text-3xl">🔒</span>
//           </div>
//           <h2 className="text-3xl font-bold text-gray-900 mb-2">Reset Your Password</h2>
//           <p className="text-gray-600">{email ? `Resetting password for ${email}` : "Create a new secure password"}</p>
//         </div>

//         <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow-lg p-8 space-y-6">
//           {/* Password Field */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-2">New Password</label>
//             <div className="relative">
//               <input
//                 type={showPassword ? "text" : "password"}
//                 name="password"
//                 value={values.password}
//                 onChange={handleChange}
//                 onBlur={handleBlur}
//                 placeholder="Enter new password"
//                 className={`w-full px-4 py-3 pr-12 border rounded-lg focus:ring-2 focus:ring-blue-500 ${errors.password ? "border-red-300" : "border-gray-300"}`}
//               />
//               <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute inset-y-0 right-0 pr-3 flex items-center">
//                 {showPassword ? <EyeSlashIcon className="h-5 w-5 text-gray-400" /> : <EyeIcon className="h-5 w-5 text-gray-400" />}
//               </button>
//             </div>
//             {errors.password && <p className="mt-1 text-sm text-red-600">{errors.password}</p>}
//           </div>

//           {/* Password Strength */}
//           {values.password && (
//             <div className="mt-2">
//               <div className="flex items-center space-x-2">
//                 <div className="flex-1 bg-gray-200 rounded-full h-2">
//                   <div className={`h-2 rounded-full transition-all ${strengthColors[Math.min(passwordStrength, 4)]}`} style={{ width: `${(passwordStrength / 5) * 100}%` }} />
//                 </div>
//                 <span className="text-xs text-gray-600">{strengthLabels[Math.min(passwordStrength, 4)]}</span>
//               </div>
//             </div>
//           )}

//           {/* Confirm Password */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-2">Confirm New Password</label>
//             <div className="relative">
//               <input
//                 type={showConfirmPassword ? "text" : "password"}
//                 name="confirmPassword"
//                 value={values.confirmPassword}
//                 onChange={handleChange}
//                 onBlur={handleBlur}
//                 placeholder="Confirm new password"
//                 className={`w-full px-4 py-3 pr-12 border rounded-lg focus:ring-2 focus:ring-blue-500 ${errors.confirmPassword ? "border-red-300" : "border-gray-300"}`}
//               />
//               <button type="button" onClick={() => setShowConfirmPassword(!showConfirmPassword)} className="absolute inset-y-0 right-0 pr-3 flex items-center">
//                 {showConfirmPassword ? <EyeSlashIcon className="h-5 w-5 text-gray-400" /> : <EyeIcon className="h-5 w-5 text-gray-400" />}
//               </button>
//             </div>
//             {errors.confirmPassword && <p className="mt-1 text-sm text-red-600">{errors.confirmPassword}</p>}
//           </div>

//           {/* Submit Button */}
//           <button type="submit" disabled={isLoading} className="w-full common-gradiant text-white py-3 rounded-xl font-semibold">
//             {isLoading ? "Resetting..." : "Reset Password"}
//           </button>

//           {/* Back Link */}
//           <div className="text-center">
//             <button type="button" onClick={() => navigate("/login")} className="text-sm text-blue-600 hover:text-blue-800">
//               Back to Login
//             </button>
//           </div>

//           {/* Global Error */}
//           {error && <p className="text-center text-red-500 text-sm">{error}</p>}
//         </form>
//       </div>
//     </div>
//   );
// };

// export default ResetPassword;
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { EyeIcon, EyeSlashIcon, CheckCircleIcon } from "@heroicons/react/24/outline";
import { useAuth } from "../../../shared/hooks/useAuth";
import { useFormValidation, validationRules } from "../../../shared/hooks/useFormValidation";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Extract token from URL
  const token = searchParams.get("token");
  const email = searchParams.get("email");

  const { resetPassword, isLoading, error, setError } = useAuth();

  const { values, errors, handleChange, handleBlur, validate } = useFormValidation(
    {
      password: "",
      confirmPassword: "",
    },
    {
      password: validationRules.password,
      confirmPassword: validationRules.confirmPassword,
    }
  );

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  // Redirect if token is missing
  useEffect(() => {
    if (!token) navigate("/forgot-password");
  }, [token, navigate]);

  // Submit Handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!validate()) return;

    // ❗ Correct API Signature: resetPassword(token, values.password)
    const result = await resetPassword(token, values.password);

    if (result) {
      setIsSuccess(true);
    }
  };

  // Password Strength Calculation
  const passwordStrength = (() => {
    const pass = values.password;
    let strength = 0;
    if (pass.length >= 8) strength++;
    if (/[a-z]/.test(pass)) strength++;
    if (/[A-Z]/.test(pass)) strength++;
    if (/\d/.test(pass)) strength++;
    if (/[!@#$%^&*]/.test(pass)) strength++;
    return Math.min(strength, 5);
  })();

  const strengthLabels = ["Very Weak", "Weak", "Fair", "Good", "Strong"];
  const strengthColors = ["bg-red-500", "bg-orange-500", "bg-yellow-500", "bg-blue-500", "bg-green-500"];

  // SUCCESS SCREEN
  if (isSuccess) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-purple-50 p-4">
        <div className="max-w-md w-full text-center space-y-6 bg-white rounded-xl shadow-lg p-8">
          <div className="mx-auto h-16 w-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
            <CheckCircleIcon className="h-8 w-8 text-green-600" />
          </div>
          <h2 className="text-3xl font-bold text-gray-900">Password Reset Successful!</h2>
          <p className="text-gray-600">Your password has been updated.</p>

          <button onClick={() => navigate("/login")} className="w-full common-gradiant text-white py-3 rounded-xl font-semibold">
            Continue to Login
          </button>
        </div>
      </div>
    );
  }

  // FORM SCREEN
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-purple-50 p-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <div className="mx-auto h-16 w-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-xl flex items-center justify-center mb-4">
            <span className="text-3xl">🔒</span>
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-2">Reset Your Password</h2>
          <p className="text-gray-600">{email ? `Resetting password for ${email}` : "Create a new secure password"}</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow-lg p-8 space-y-6">
          {/* Password */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">New Password</label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={values.password}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Enter new password"
                className={`w-full px-4 py-3 pr-12 border rounded-lg focus:ring-2 focus:ring-blue-500 ${errors.password ? "border-red-300" : "border-gray-300"}`}
              />
              <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute inset-y-0 right-0 pr-3 flex items-center">
                {showPassword ? <EyeSlashIcon className="h-5 w-5 text-gray-400" /> : <EyeIcon className="h-5 w-5 text-gray-400" />}
              </button>
            </div>
            {errors.password && <p className="mt-1 text-sm text-red-600">{errors.password}</p>}
          </div>

          {/* Password Strength Bar */}
          {values.password && (
            <div className="mt-2">
              <div className="flex items-center space-x-2">
                <div className="flex-1 bg-gray-200 rounded-full h-2">
                  <div
                    className={`h-2 rounded-full ${strengthColors[passwordStrength - 1]}`}
                    style={{
                      width: `${((passwordStrength - 1) / 4) * 100}%`,
                    }}
                  />
                </div>
                <span className="text-xs text-gray-600">{strengthLabels[passwordStrength - 1]}</span>
              </div>
            </div>
          )}

          {/* Confirm Password */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Confirm New Password</label>
            <div className="relative">
              <input
                type={showConfirmPassword ? "text" : "password"}
                name="confirmPassword"
                value={values.confirmPassword}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Confirm new password"
                className={`w-full px-4 py-3 pr-12 border rounded-lg focus:ring-2 focus:ring-blue-500 ${errors.confirmPassword ? "border-red-300" : "border-gray-300"}`}
              />
              <button type="button" onClick={() => setShowConfirmPassword(!showConfirmPassword)} className="absolute inset-y-0 right-0 pr-3 flex items-center">
                {showConfirmPassword ? <EyeSlashIcon className="h-5 w-5 text-gray-400" /> : <EyeIcon className="h-5 w-5 text-gray-400" />}
              </button>
            </div>
            {errors.confirmPassword && <p className="mt-1 text-sm text-red-600">{errors.confirmPassword}</p>}
          </div>

          {/* Submit */}
          <button type="submit" disabled={isLoading} className="w-full common-gradiant text-white py-3 rounded-xl font-semibold">
            {isLoading ? "Resetting..." : "Reset Password"}
          </button>

          {error && <p className="text-center text-red-500 text-sm">{error}</p>}
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
